import * as Backend from '@/core/backend'

export class UserDetail {
  constructor (data) {
    // console.log('--> UserDetail: Creating new User Detail from data: ', data)
    if (data) {
      this.UserId = data.UserId
      this.Name = data.Name
      this.Id = data.Id
      this.Value = data.Value
      this.Data1 = data.Data1
      this.Data2 = data.Data2
      this.Data3 = data.Data3
    }
  }

  async save () {
    if (process.env.NODE_ENV === 'development') console.log('--> UserDetail: Saving User Detail: ', this)
    const res = await Backend.callApi({
      apiName: 'Admin.SaveUserDetail',
      inputData: {
        UserDetail: this
      }
    })
    return res
  }

  static async load (userId, name) {
    if (process.env.NODE_ENV === 'development') console.log('--> UserDetail: Loading User Detail: ', userId, name)
    const res = await Backend.callApi({
      apiName: 'Admin.LoadUserDetail',
      inputData: {
        UserId: userId,
        DetailName: name
      }
    })
    let userDetail = null
    // console.log('--> UserDetail: Load promise from ' + name, res)
    if (res && res.data) {
      userDetail = await new UserDetail(res.data)
    } else {
      userDetail = await new UserDetail({ UserId: userId, Name: name })// Since we want a new UserDetail, create one to work with
    }
    // console.log('--> UserDetail: Loaded User Detail: ', userDetail)
    return userDetail
  }
}
